/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Circle, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function Shower(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Circle cx={60} cy={228} r={16} />
      <Circle cx={92} cy={196} r={16} />
      <Circle cx={28} cy={196} r={16} />
      <Circle cx={60} cy={164} r={16} />
      <Path
        d="M244,40H219.31371a8,8,0,0,0-5.65686,2.34315L184,72,64.39532,86.07114A8,8,0,0,0,59.6732,99.6732l96.6536,96.6536a8,8,0,0,0,13.60206-4.72212L184,72"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={24}
      />
    </Svg>
  );
}

export default Shower;
